import * as yup from 'yup';
import dayjs from 'dayjs';
import { dateSchema, requiredErrorMessage } from '@common/schema';

export const addTimeOffSchema = yup.object().shape({
  start_date: dateSchema.required(requiredErrorMessage),
  end_date: dateSchema.required(requiredErrorMessage),

  days: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? undefined : value,
    )
    .typeError('Days must be a valid number')
    .positive('Days must be greater than 0')
    .required(requiredErrorMessage)

    .test(
      'integer-or-fraction-only-under-1',
      'Days must be a whole number unless it is between 0 and 1',
      value => {
        if (value === undefined || value === null) return true;

        if (value <= 1) {
          return value > 0;
        }

        return Number.isInteger(value);
      },
    )

    .test(
      'matches-date-range',
      'Days must be less or equal to the selected date range',
      function (value) {
        const { start_date, end_date } = this.parent;

        if (!value || !start_date || !end_date) {
          return true;
        }

        const start = dayjs(start_date).startOf('day');
        const end = dayjs(end_date).startOf('day');

        if (!start.isValid() || !end.isValid()) {
          return true;
        }

        const inclusiveDays = end.diff(start, 'day') + 1;

        if (inclusiveDays <= 0) {
          return this.createError({
            message: 'End date must be after or equal to start date',
          });
        }

        if (inclusiveDays === 1) {
          return value > 0 && value <= 1;
        }

        return value > 0 && value <= inclusiveDays;
      },
    ),

  user_id: yup.string().required(requiredErrorMessage),
});
